import Bluebird from 'bluebird'
import transitionPath from 'router5-transition-path'
import { findRoutes }  from '../utils'

import {
  MiddlewareFactory,
  RouteTriggerHandler,
} from '../../../types/frontend/router'

import {
  AppRoute,
} from '../../../types/frontend/router'

import {
  RootState,
} from '../../../types/frontend/store_generic'

/*

  trigger actions when routes become active

*/
function TriggerMiddlewareFactory<RootStateType extends RootState = RootState>() {
  const triggerRoute: MiddlewareFactory<RootStateType> = (routes) => (router, dependencies) => async (toState, fromState, done) => {
    const {
      toActivate,
      toDeactivate,
    } = transitionPath(toState, fromState)
    const { store } = dependencies

    const deactiveRoutes = findRoutes(routes as AppRoute<RootState>[], toDeactivate)
    const activeRoutes = findRoutes(routes as AppRoute<RootState>[], toActivate)
    
    const deactiveTriggers = deactiveRoutes.reduce<RouteTriggerHandler[]>((all, route) => {
      return all.concat(route.onLeave || [])
    }, [])

    const activeTriggers = activeRoutes.reduce<RouteTriggerHandler[]>((all, route) => {
      return all.concat(route.onEnter || [])
    }, [])

    await Bluebird.each(deactiveTriggers, async trigger => {
      await trigger(store, fromState.params)
    })

    await Bluebird.each(activeTriggers, async trigger => {
      await trigger(store, toState.params)
    })
  }
  return triggerRoute
}

export default TriggerMiddlewareFactory